// Data access layer for Landmark District application
import shopsData from './shops.json';

export const getShops = () => shopsData.shops;
